module.exports = __webpack_public_path__ + "static/fleet-70-seat-coach-sm-c6fb0870f42ef86197534b0cc24e15f9.jpg";